// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgq_a","AdSlotBranding__desktop":"bgq_b","AdSlotBranding__mobile":"bgq_c"};